module.exports = __webpack_public_path__ + "html/chart.component.html";